import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationNodeActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Node/NodeBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationNode"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationNode"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationNodeActivity)
